import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateOrderTrackingId } from "../actions/order";
import { Spinner } from "react-bootstrap";

const TrackingNumber = ({ email, orderId }) => {
  const dispatch = useDispatch();
  const [trackingNumber, setTrackingNumber] = useState("");
  const [showMessage, setShowMessage] = useState("");
  const [messageVariant, setMessageVariant] = useState("");

  const trackingState = useSelector((state) => state.orderTrackingId);
  const { loading, error, success } = trackingState;

  const handleSendTracking = () => {
    if (!trackingNumber) {
      setShowMessage("Please enter a tracking number.");
      setMessageVariant("danger");
      return;
    }

    dispatch(updateOrderTrackingId(email, trackingNumber, orderId));
  };

  useEffect(() => {
    if (success) {
      setTrackingNumber("");
      setShowMessage(`Tracking number sent successfully to ${email}`);
      setMessageVariant("success");
    }
    setTimeout(() => {
      setShowMessage("");
    }, 3000);
  }, [success]);

  useEffect(() => {
    if (error) {
      setShowMessage(error);
      setMessageVariant("danger");
    }
    setTimeout(() => {
      setShowMessage("");
    }, 5000);
  }, [error]);

  return (
    <div style={{ marginTop: "40px", padding: "20px 0", textAlign: "center" }}>
      <h2>Send Tracking Number</h2>
      <p>
        Enter the tracking number below to send it to <strong>{email}</strong>.
      </p>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "10px",
          maxWidth: "500px",
          margin: "auto",
        }}
      >
        <input
          type="text"
          placeholder="Enter tracking number"
          value={trackingNumber}
          onChange={(e) => setTrackingNumber(e.target.value)}
          style={{
            padding: "10px",
            border: "1px solid #ccc",
            borderRadius: "5px",
            width: "100%",
          }}
        />
        <button
          onClick={handleSendTracking}
          disabled={!trackingNumber || loading}
          style={{
            minHeight: "40px",
            padding: "0 15px",
            backgroundColor: "black",
            color: "white",
            border: "1px solid black",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = "#514f4f";
            e.target.style.color = "white";
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = "black";
            e.target.style.color = "white";
          }}
        >
          {loading ? (
            <>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />{" "}
              Sending...
            </>
          ) : (
            "Send"
          )}
        </button>
      </div>

      {showMessage && (
        <small
          style={{
            display: "block",
            marginTop: "10px",
            color: messageVariant === "success" ? "green" : "#dc3545",
            fontSize: "15px",
          }}
        >
          {showMessage}
        </small>
      )}
    </div>
  );
};

export default TrackingNumber;
